import { render, staticRenderFns } from "./cartItem.vue?vue&type=template&id=4f8982fc"
import script from "./cartItem.vue?vue&type=script&lang=js"
export * from "./cartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Counter: require('/vercel/path0/components/ui/counter.vue').default})
